import {
  FieldHelperProps,
  FieldInputProps,
  FieldMetaProps,
  useField
} from 'formik'
import { useHelperText } from './useHelperText'

interface FieldProps<ValueType>
  extends Pick<FieldInputProps<ValueType>, 'onBlur' | 'onChange' | 'value'>,
    Pick<FieldMetaProps<ValueType>, 'error'>,
    Pick<FieldHelperProps<ValueType>, 'setValue'> {
  helperText: string | undefined
}

export const useFieldProps = <ValueType,>(
  name: string,
  checkErrors = true
): FieldProps<ValueType> => {
  const [field, meta, helpers] = useField<ValueType>(name)
  const { value, onBlur, onChange } = field
  const { setValue } = helpers
  const error = checkErrors ? meta.error : undefined

  const helperText = useHelperText(error)

  return {
    error,
    helperText,
    onBlur,
    onChange,
    setValue,
    value
  }
}
